import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FloatingTooltip, FloatingTooltipContentText } from '../../Floating'
import Text from '../../Text'
import { QA_NAME_DASHBOARD_BIRDVIEW_ENTITY_TITLE } from '../DashboardBirdview.constants.qa'

import * as styles from './BirdviewEntityTitle.module.css'

function BirdviewEntityTitle({
  className = styles.title,
  isUnread,
  number,
  title,
  onOpen,
}) {
  const { t } = useTranslation()

  return (
    <FloatingTooltip
      content={
        <FloatingTooltipContentText
          additionalText={t('DashboardBirdview.ClickToOpenTooltipKey')}
          text={title}
        />
      }
      disabled={!onOpen}
    >
      <Text
        className={classNames(className, { [styles.interactive]: onOpen })}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_ENTITY_TITLE}
        title={onOpen ? undefined : title}
        unread={isUnread}
        onClick={onOpen}
      >
        {number ? <Text className={styles.number}>{number}</Text> : null}
        {title}
      </Text>
    </FloatingTooltip>
  )
}

export default BirdviewEntityTitle
